import AppStore from "stores/app";
import AppApi from "apis/app";
import IBrick from "types/brick";
import IControl from "types/control";

/*

export const bricks = () => {
    const url = '/bricks';
    return {
        // getAll: () => axios.get('https://my-json-server.typicode.com/sampleu/vavanyaAPI/bricks'),
        [+] getAll: () => axios.get(url),
        [+] create: (toCreate) => axios.post(url, toCreate),
        [+] update: ({ id, toUpdate }) => axios.patch(`${url}/${id}`, toUpdate),
        [-] getOne: ({ id }) => axios.get(`${url}/${id}`),
        [-] delete: ({ id }) => axios.delete(`${url}/${id}`)
    };
};

*/
export default class BrickApi {
    private readonly url = '/bricks';

    constructor(private api: AppApi, private store: AppStore) { }

    async getAll() {
        const res = await this.api.client.get(this.url);
        this.store.brick.load(res.data.map((brickJson: any) => this.payloadToBrick(brickJson)));
    }

    async create(brickJson: any) {
        let brick: IBrick | null = null;
        try {
            brickJson.controls = brickJson.controls.map((ctrl: any) => { return { ...ctrl, ID: ctrl.ID ? ctrl.ID : '<api-none>' }; });
            console.log('controls', brickJson.controls);
            const brickPayload: string = JSON.stringify(brickJson);
            console.log('brickPayload', brickPayload);
            const res = await this.api.client.post(this.url, brickPayload);
            brick = this.payloadToBrick(res.data);
            this.store.brick.add(brick);
        }
        catch { }
        console.log('brick', brick);
        return brick;
    }

    async update(id: string, brickJson: any) {
        const result = await this.updateWithResult(id, brickJson);
        return result.status === 'success' ? result.brick : null;
    }

    async updateWithResult(id: string, brickJson: any): Promise<{ status: 'success'; brick: IBrick } | { status: 'failure' | 'unconfirmed' }> {
        try {
            const res = await this.api.client.patch(`${this.url}/${id}`, brickJson);
            if (typeof res.status !== 'number' || res.status < 200 || res.status >= 300) {
                return { status: res.status >= 400 && res.status < 500 ? 'failure' : 'unconfirmed' };
            }
            const data = res.data;
            if (!data || data.id !== id || typeof data.brick_caption !== 'string' ||
                typeof data.brick_type !== 'string' || !Array.isArray(data.controls) ||
                !data.controls.every((control: any) => control && typeof control._id === 'string' &&
                    !!control._id && typeof control.name === 'string' && typeof control.type === 'string' &&
                    typeof control.ID === 'string') ||
                new Set(data.controls.map((control: any) => control._id)).size !== data.controls.length ||
                (Array.isArray(brickJson.controls) && (brickJson.controls.length !== data.controls.length ||
                    !brickJson.controls.every((control: any) => !control._id ||
                        data.controls.some((saved: any) => saved._id === control._id))))) {
                return { status: 'unconfirmed' };
            }
            const brick = this.payloadToBrick(data);
            // update tree node
            const treeNode = this.store.brickTree.nodes.find(node => node.data?.reference_id === id);
            if (treeNode && treeNode.text !== brick.name) {
                this.api.brickTree.update(treeNode.id, { text: brick.name });
            }
            this.store.brick.update(brick);
            return { status: 'success', brick };
        }
        catch (error: any) {
            const status = error?.response?.status;
            return { status: status >= 400 && status < 500 ? 'failure' : 'unconfirmed' };
        }
    }

    async delete(id: string) {
        let brick: IBrick | null = null;
        try {
            const res = await this.api.client.delete(`${this.url}/${id}`);
            brick = this.payloadToBrick(res.data);
            this.store.brick.update(brick);
        }
        catch { }
        console.log('brick', brick);
        return brick;
    }

    private payloadToBrick(brickJson: any): IBrick {
        const mappedControls = brickJson.controls.map((controlJson: any) => {
            const mappedControl = {
                id: controlJson._id,
                type: controlJson.type,
                name: controlJson.name,
                anchor: controlJson.ID
            };
            return mappedControl as IControl;
        }) || [];

        const mappedBrick = {
            id: brickJson.id,
            name: brickJson.brick_caption,
            type: brickJson.brick_type,
            anchor: 'NOT-IMPL', //brickJson.ID,
            controls: mappedControls as IControl[]
        };
        return mappedBrick as IBrick;
    }
    //   async getById(id: number) {
    //     const res = await this.api.client.get(`/posts/${id}`);
    //     this.store.post.load([res.data]);
    //   }
}
